import DatePickerRangeButton from '@/modules/drivers/shared/datepickers/DatePickerRangeButton'
import { DatePickerRangeProps } from '@/modules/drivers/types'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

import * as React from 'react'

interface HeadBarProps {
  title: string
  icon: React.ReactElement
  handleDateRangeChange: (dateRange: DatePickerRangeProps) => void
  range: DatePickerRangeProps
}

export const HeadBar = ({
  title,
  icon,

  handleDateRangeChange,
  range,
}: HeadBarProps) => {
  const { t } = useLocalize()
  return (
   <div className="tw-items-left tw-flex tw-gap-6 tw-justify-between tw-rounded-t-xl tw-border-b tw-p-4">
      <div className="tw-flex tw-items-center tw-gap-4">
        <div className="tw-flex tw-items-center tw-rounded-t-xl">
          <div className="tw-mr-1">{icon}</div>
          <div className="tw-flex-1 tw-text-xl tw-font-semibold">{title}</div>
        </div>
      </div>
      <div className="tw-flex tw-items-center tw-gap-3">
        <p className="tw-color-content-base tw-font-sm">
          {t('common.date-range')}
        </p>
        <DatePickerRangeButton
          iconAlign="left"
          size="small"
          highlightSelected={true}
          onChange={handleDateRangeChange}
          initialDate={range}
          clearable={false}
        />
      </div>
    </div>
  )
}
